import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { reviewsApi } from '../api/reviewsApi';
import { reviewKeys } from '../queryKeys';

export function useReviewStats() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  return useQuery({
    queryKey: reviewKeys.stats(locationId),
    queryFn: () => reviewsApi.getStats(locationId),
    enabled: !!locationId,
  });
}
